// documentGenerationService.js

const INCIDENT_FUNCTION_URL =
  "https://us-central1-tcmedicalwebportal.cloudfunctions.net/generateIncidentReport";

const RX_FUNCTION_URL =
  "https://us-central1-tcmedicalwebportal.cloudfunctions.net/generateRxPrescription";

async function postJson(url, body) {
  const response = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "text/plain;charset=utf-8",
    },
    body: JSON.stringify(body),
  });

  const rawText = await response.text();

  let data = {};
  try {
    data = JSON.parse(rawText);
  } catch {
    throw new Error(`Could not parse Cloud Function response: ${rawText}`);
  }

  if (!response.ok) {
    throw new Error(data?.error || rawText || "Document generation failed.");
  }

  if (!data?.success) {
    throw new Error(data?.error || "Document generation failed.");
  }

  return data;
}

export async function generateIncidentReportPdf({
  patientId,
  encounterId,
  templateData,
  patient,
  encounter,
  photos = [],
}) {
  return postJson(INCIDENT_FUNCTION_URL, {
    action: "generateIncidentReport",
    patientId,
    encounterId,
    patient,
    encounter,
    templateData,
    photos,
    encounterRefPath: `patients/${patientId}/encounters/${encounterId}`,
  });
}

export async function generateRxPrescriptionPdf({
  patientId,
  encounterId,
  patient,
  encounter,
  providerUid,
  providerPin,
  provider = null,
  providerName = "",
  providerDEA = "",
  providerNPI = "",
  medications = [],
}) {
  return postJson(RX_FUNCTION_URL, {
    action: "generateRxPrescription",
    patientId,
    encounterId,
    patient,
    encounter,
    providerUid,
    providerPin,
    provider,
    providerName,
    providerDEA,
    providerNPI,
    medications,
    encounterRefPath: `patients/${patientId}/encounters/${encounterId}`,
  });
}